import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { IRows } from "../../../Components/Filter/WSFilterComponent";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const UserList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
  useEffect(() => {
    updateMainHeader("Administration");
  }, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "User Management": "/user/list" },
  ]);

  const source = {
    url: "users/list",  // ✅ Fixed API path
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };

  const columns: IColumns[] = [
    { header: "Name", fieldName: "full_name" },
    { header: "Email", fieldName: "email" },
    { header: "Phone No", fieldName: "phone", tooltip: true },
    { header: "Role", fieldName: "role", tooltip: true },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        
        // ✅ Fixed: Handle different ID field names
        const userId = row.user_id || row.id || row.UserId || row._id;
        
        if (!userId) {
          console.error("❌ No valid ID found in row:", row);
          showMessage("Invalid user data - missing ID", "error");
          return;
        }
        
        if (action === "Edit") {
          navigate(`/user/${userId}`);
        } else if (action === "Delete") {
          setSelectedId(userId);
          setPopupOpen(true);
        }
      },
    },
  ];

  // Filters (UI only)
  const filterRows: IRows[] = [
    {
      label: "Name",
      fieldName: "full_name",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Email",
      fieldName: "email",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Phone",
      fieldName: "phone",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
    {
      label: "Role",
      fieldName: "role",
      type: "text",
      operator: "like",
      rowDivision: 6,
    },
  ];

  const handleClick = () => {
    navigate("/user");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="userGrid"
            title="User Management"
            headerType="modern"
            columns={columns}
            source={source}
            filterFields={filterRows}
            rowsPerPageCount={10}
            searchBox={{ fieldName: "full_name" }}
            addButton={{ label: "Add New User", color: "secondary" }}
            onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
        
        {}
        <ConfirmationPopup
          type="DELETE"
          apiUrl="users"  // ✅ Fixed: Remove "api/v1/" prefix
          id={selectedId}
          confirmMessage="Are you sure you want to delete this user?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("userGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.message || "Delete failed", "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
